import {FormEvent, MouseEvent, useCallback, useRef} from 'react';
import {UrlLink} from '../../../applink/UrlLink';
import {
  PC_SEARCH_MODAL_ROOT_ID,
  SEARCH_INPUT_MAX_LENGTH,
} from '../../../domain/search/constant';
import {LOG_SEARCH_CLICK} from '../../../logging/logEvent';
import {putTiaraObjectProps} from '../../../logging/putTiaraObjectProps';
import {Icon} from '../../atoms/Icon/Icon';
import {IconType} from '../../atoms/Icon/IconType.enum';
import {GnbSearchInputFieldProps} from './GnbSearchInputFieldProps.interface';

/**
 * 인풋필드 - GNB검색에 해당하는 organism 입니다.
 * https://www.figma.com/file/mM95GNIeS97wxw0TmIBwIj/NEXT-Page-%EC%B5%9C%EC%A2%85-%EC%B7%A8%ED%95%A9_WEB?node-id=7138%3A279262
 */
export function GnbSearchInputField({
  onSubmit,
  onClickRemoveButton,
  value,
  className,
  isMobile,
  ...inputProps
}: GnbSearchInputFieldProps) {
  const inputRef = useRef<HTMLInputElement>(null);
  const handleSubmit = useCallback(
    (event: FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      LOG_SEARCH_CLICK('입력검색어_실행', event, () => {
        onSubmit?.();
        inputRef.current?.blur();
      });
    },
    [onSubmit]
  );

  const onClickSearch = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      onSubmit?.();
      inputRef.current?.blur();
    },
    [onSubmit]
  );

  const onClickRemoveText = useCallback(
    (e: MouseEvent) => {
      e.stopPropagation();
      onClickRemoveButton?.(e);
      inputRef.current?.focus();
    },
    [onClickRemoveButton]
  );
  return (
    <form
      onSubmit={handleSubmit}
      className="relative flex h-34pxr w-full items-center rounded-full border-1 border-solid border-theme-transparent-20 pl-12pxr pr-8pxr"
      id={PC_SEARCH_MODAL_ROOT_ID}
      {...putTiaraObjectProps({
        click: {
          layer1: '상단',
        },
      })}
    >
      <div className="flex w-full items-center">
        <input
          className="font-small1 flex-1 bg-transparent text-theme-solid-100 outline-hidden placeholder:text-[rgb(var(--colors-theme-solid-60)_/_60%)]"
          ref={inputRef}
          value={value}
          maxLength={SEARCH_INPUT_MAX_LENGTH}
          {...inputProps}
          // size의 기본 내장값이 20이기 때문에 20글자를 보여줄 수 있는 너비로 브라우저에서 min-width를 알아서 잡아버리므로 size를 1로 수정합니다
          size={1}
        />
        {value && (
          <button type="button" onClick={onClickRemoveText}>
            <Icon
              className="ml-4pxr box-content shrink-0 cursor-pointer overflow-hidden bg-cover bg-no-repeat"
              ariaHidden={false}
              type={IconType.InputboxDelete}
            />
          </button>
        )}
      </div>
      <UrlLink
        url={
          value
            ? `/search/result?keyword=${encodeURIComponent(value as string)}`
            : undefined
        }
        className="shrink-0"
        aria-label="검색, 버튼"
      >
        <Icon
          type={IconType.SearchButtonPc}
          className="cursor-pointer ml-4pxr"
          onClick={onClickSearch}
        />
      </UrlLink>
    </form>
  );
}
